interface Point2D {
  readonly X: number;
  readonly Y: number;
}

interface Point3D {
  readonly X: number;
  readonly Y: number;
  readonly Z: number;
}

interface PanelOpening {
  readonly name: string;
  readonly topHeight: number;
  readonly bottomHeight: number;
  readonly points: readonly Point2D[];
  readonly openingWidth: number;
  readonly id: number;
  readonly type: 'Door' | 'Window';
}

interface Wall {
  readonly thickness: number;
  readonly topheight: number;
  readonly bottomheight: number;
  readonly isExterior: 'true' | 'false';
  readonly isLoadBearing: 'true' | 'false';
  readonly wallPoints: readonly Point2D[];
  readonly topSlopePoints: readonly Point3D[];
  readonly botSlopePoints: readonly Point3D[];
  readonly wallDirection: 'CounterClockWise';
  readonly panelOpenings: readonly PanelOpening[] | null;
  readonly id: number;
  readonly type: 'Wall';
}

interface FloorLevel {
  readonly name: string;
  readonly height: number;
  readonly wallheight: number;
  readonly walls: readonly Wall[];
}

interface CrowdBuildJson {
  readonly VersionNumber: string;
  readonly Country: string;
  readonly FloorLevels: readonly FloorLevel[];
}

export function parseCrowdBuildJson(crowdBuildJson: string) {
  return JSON.parse(crowdBuildJson) as CrowdBuildJson;
}
